import { createAction, props } from '@ngrx/store';
const addCalcInfo = createAction('[Calc Info] Add Calc Info', props());
export { addCalcInfo };
